import React from 'react';
import {FlatList, ListRenderItemInfo} from 'react-native';
import {useLinkTo} from '@react-navigation/native';

import ActorListItem from './ActorListItem';

import {ListItemNormalSeparator} from '@/components/ui/lists/separators';
import {BottomButton} from '@/components/ui/buttons';

import Actor from '@/entities/Actor';

interface Props {
  actors: Actor[];
  onNotifyActorDelete: (actor: Actor) => void;
  onEndReached?: ((info: {distanceFromEnd: number}) => void) | null | undefined;
}

const ActorList: React.FC<Props> = props => {
  const {actors, onNotifyActorDelete, onEndReached} = props;
  const linkTo = useLinkTo();
  const renderItem = React.useCallback((info: ListRenderItemInfo<Actor>) => {
    return (
      <ActorListItem
        actor={info.item}
        onNotifyActorDelete={onNotifyActorDelete}
      />
    );
  }, []);
  const onPress = React.useCallback(() => linkTo('/actors/new'), []);
  return (
    <>
      <FlatList
        data={actors}
        contentContainerStyle={style}
        renderItem={renderItem}
        ItemSeparatorComponent={ListItemNormalSeparator}
        ListFooterComponent={ListItemNormalSeparator}
        onEndReached={onEndReached}
      />
      <BottomButton onPress={onPress}>新しいイラストを登録する</BottomButton>
    </>
  );
};

export default React.memo(ActorList);

const style = {
  paddingBottom: 78,
};
